import { render, staticRenderFns } from "./CommentSwiper.vue?vue&type=template&id=ace014dc&scoped=true&"
import script from "./CommentSwiper.vue?vue&type=script&lang=ts&"
export * from "./CommentSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./CommentSwiper.vue?vue&type=style&index=0&id=ace014dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace014dc",
  null
  
)

export default component.exports